(() => {
  const root = document.querySelector('[data-product-config]');
  const form = document.getElementById('MainProductForm');
  if (!root || !form || form.dataset.ready) return;
  form.dataset.ready = 'true';
  const config = JSON.parse(root.textContent);
  const variants = config.variants;
  const money = new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: config.currency });
  const formatMoney = cents => money.format(cents / 100);
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const carousel = document.getElementById('PdpCarousel');
  const slides = Array.from(carousel.querySelectorAll('.pdp__carousel-slide'));
  const thumbs = Array.from(document.querySelectorAll('.pdp__thumb'));
  const dots = Array.from(document.querySelectorAll('.pdp__dot'));
  const cards = Array.from(form.querySelectorAll('.pdp__bundle-card'));
  const swatches = Array.from(form.querySelectorAll('.pdp__swatch'));
  const buy = form.querySelector('.pdp__buy');
  const stickyBuy = document.getElementById('PdpStickyBuy');
  const stickyBar = document.getElementById('PdpStickyBar');
  const variantInput = document.getElementById('VariantId');
  const qtyInput = document.getElementById('BundleQty');
  const price = document.getElementById('BundlePrice');
  const compare = document.getElementById('ComparePrice');
  const badge = document.getElementById('PriceBadge');
  const feedback = document.getElementById('ProductFeedback');
  const summary = document.getElementById('BundleSummary');
  const modal = document.getElementById('BundleModal');
  const slots = document.getElementById('BundleModalSlots');
  const confirm = document.getElementById('BundleModalConfirm');
  const selected = (variants.find(v => String(v.id) === variantInput.value) || variants[0]).options.slice();
  let currentImage = 0;
  let bundle = null;
  let pendingCard = null;
  let busy = false;
  let savedOverflow = '';

  const currentVariant = () => variants.find(v => v.options.every((value, i) => value === selected[i]));
  const activeCard = () => cards.find(card => card.classList.contains('active')) || cards[0];
  function goTo(index) {
    if (!slides.length) return;
    currentImage = (index + slides.length) % slides.length;
    carousel.scrollTo({ left: carousel.clientWidth * currentImage, behavior: reducedMotion ? 'auto' : 'smooth' });
    thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('active', i === currentImage);
      thumb.setAttribute('aria-pressed', String(i === currentImage));
    });
    dots.forEach((dot, i) => dot.classList.toggle('active', i === currentImage));
  }
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => goTo(index)));
  let touchStart;
  carousel.addEventListener('touchstart', event => {
    touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  carousel.addEventListener('touchend', event => {
    if (!touchStart) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goTo(currentImage + (dx < 0 ? 1 : -1));
    touchStart = null;
  }, { passive: true });
  new ResizeObserver(() => {
    carousel.scrollTo({ left: carousel.clientWidth * currentImage, behavior: 'instant' });
  }).observe(carousel);

  function clearError() {
    feedback.hidden = true;
    feedback.textContent = '';
  }
  function setCard(card) {
    cards.forEach(item => {
      const active = item === card;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    qtyInput.value = card.dataset.qty;
  }
  function sync() {
    const variant = currentVariant();
    const card = activeCard();
    const qty = Number(card.dataset.qty);
    const valid = bundle ? bundle.length === qty && bundle.every(v => v.available) : variant && variant.available;
    buy.disabled = busy || !valid;
    buy.setAttribute('aria-disabled', String(buy.disabled));
    buy.textContent = busy ? config.labels.adding : valid ? config.labels.add : variant ? config.labels.soldOut : config.labels.unavailable;
    stickyBuy.disabled = buy.disabled;
    stickyBuy.textContent = buy.textContent;
    cards.forEach(item => { item.disabled = busy || (Number(item.dataset.qty) > 1 && config.colourIndex >= 0 && colourVariants().length === 0); });
    if (!variant) {
      price.textContent = config.labels.unavailable;
      document.getElementById('PdpStickyPrice').textContent = config.labels.unavailable;
      if (compare) compare.hidden = true;
      badge.hidden = true;
      summary.hidden = true;
      return;
    }
    variantInput.value = variant.id;
    cards[0].dataset.unitPriceCents = variant.price;
    const singlePrice = cards[0].querySelector('.pdp__bundle-price');
    singlePrice.firstChild.textContent = formatMoney(variant.price) + ' ';
    const unitPrice = qty > 1 ? Number(card.dataset.unitPriceCents) || variant.price : variant.price;
    const total = qty * unitPrice;
    price.textContent = formatMoney(total);
    document.getElementById('PdpStickyPrice').textContent = formatMoney(total);
    const compareTotal = (variant.compare_at_price || 0) * qty;
    if (compare) {
      compare.hidden = compareTotal <= total;
      compare.textContent = formatMoney(compareTotal);
    }
    badge.hidden = compareTotal <= total;
    if (!badge.hidden) badge.textContent = config.labels.save.replace('__percent__', Math.round((1 - total / compareTotal) * 100));
    document.getElementById('PriceNote').textContent = qty > 1 ? config.labels.bundleNote : config.labels.priceNote;
    summary.hidden = !bundle;
    if (bundle) summary.textContent = config.labels.summary.replace('__colours__', bundle.map(v => v.options[config.colourIndex]).join(', '));
  }
  swatches.forEach(swatch => swatch.addEventListener('click', () => {
    if (busy) return;
    const index = Number(swatch.dataset.optionIndex);
    selected[index] = swatch.dataset.value;
    swatches.filter(item => Number(item.dataset.optionIndex) === index).forEach(item => {
      const active = item === swatch;
      item.classList.toggle('active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    swatch.closest('.pdp__option').querySelector('.pdp__option-val').textContent = ' — ' + selected[index];
    bundle = null;
    setCard(cards[0]);
    clearError();
    const variant = currentVariant();
    if (variant) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      const imageIndex = config.imageIds.indexOf(variant.featured_image && variant.featured_image.id);
      if (imageIndex >= 0) goTo(imageIndex);
    }
    sync();
  }));

  function colourVariants() {
    return variants.filter(variant => variant.available && variant.options.every((value, index) => index === config.colourIndex || value === selected[index]));
  }
  function openModal(card) {
    pendingCard = card;
    slots.replaceChildren();
    const choices = colourVariants();
    const qty = Number(card.dataset.qty);
    document.getElementById('BundleModalTitle').textContent = config.labels.bundleTitle.replace('__count__', qty);
    for (let i = 0; i < qty; i++) {
      const slot = document.createElement('div');
      slot.dataset.slot = i;
      const label = document.createElement('p');
      label.className = 'bundle-modal__slot-label';
      label.id = 'BundleSlotLabel-' + i;
      label.textContent = config.labels.tagColour.replace('__count__', i + 1);
      const group = document.createElement('div');
      group.className = 'bundle-modal__swatches';
      group.setAttribute('role', 'group');
      group.setAttribute('aria-labelledby', label.id);
      const chosen = (bundle && bundle[i]) || currentVariant();
      choices.forEach(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'bundle-modal__swatch';
        button.textContent = variant.options[config.colourIndex];
        button.dataset.variantId = variant.id;
        const active = chosen && variant.id === chosen.id;
        button.classList.toggle('active', active);
        button.setAttribute('aria-pressed', String(Boolean(active)));
        button.addEventListener('click', () => {
          group.querySelectorAll('button').forEach(item => {
            item.classList.toggle('active', item === button);
            item.setAttribute('aria-pressed', String(item === button));
          });
          confirm.disabled = slots.querySelectorAll('button.active').length !== qty;
        });
        group.append(button);
      });
      slot.append(label, group);
      slots.append(slot);
    }
    confirm.disabled = slots.querySelectorAll('button.active').length !== qty;
    savedOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    modal.showModal();
    modal.classList.add('open');
  }
  function closeModal() { modal.close(); }
  modal.addEventListener('close', () => {
    modal.classList.remove('open');
    document.body.style.overflow = savedOverflow;
    const trigger = pendingCard;
    pendingCard = null;
    if (trigger) trigger.focus();
  });
  document.getElementById('BundleModalClose').addEventListener('click', closeModal);
  modal.addEventListener('click', event => { if (event.target === modal) closeModal(); });
  confirm.addEventListener('click', () => {
    if (!pendingCard || confirm.disabled) return;
    bundle = Array.from(slots.querySelectorAll('button.active')).map(button => variants.find(v => String(v.id) === button.dataset.variantId));
    setCard(pendingCard);
    clearError();
    sync();
    closeModal();
  });
  cards.forEach(card => card.addEventListener('click', () => {
    if (busy) return;
    clearError();
    if (Number(card.dataset.qty) > 1 && config.colourIndex >= 0) {
      openModal(card);
    } else {
      bundle = null;
      setCard(card);
      sync();
    }
  }));

  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || buy.disabled) return;
    const card = activeCard();
    const discount = card.dataset.discount;
    const qty = Number(card.dataset.qty);
    const items = [];
    if (bundle) {
      bundle.forEach(variant => {
        const existing = items.find(item => item.id === variant.id);
        if (existing) existing.quantity++;
        else items.push({ id: variant.id, quantity: 1 });
      });
    } else {
      items.push({ id: currentVariant().id, quantity: qty });
    }
    busy = true;
    clearError();
    form.setAttribute('aria-busy', 'true');
    [...cards, ...swatches].forEach(button => { button.disabled = true; });
    sync();
    try {
      const response = await fetch(config.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.labels.error);
      if (typeof window.fbq === 'function') {
        try {
          window.fbq('track', 'AddToCart', { content_ids: items.map(item => String(item.id)), content_type: 'product', num_items: qty, currency: config.currency, value: Number(card.dataset.unitPriceCents) * qty / 100 });
        } catch (_) {}
      }
      window.location.assign(discount ? config.rootUrl + 'discount/' + encodeURIComponent(discount) + '?redirect=' + encodeURIComponent(config.cartUrl) : config.cartUrl);
    } catch (error) {
      feedback.textContent = error.message || config.labels.error;
      feedback.hidden = false;
      feedback.scrollIntoView({ block: 'nearest', behavior: reducedMotion ? 'auto' : 'smooth' });
      busy = false;
      form.removeAttribute('aria-busy');
      [...cards, ...swatches].forEach(button => { button.disabled = false; });
      sync();
    }
  });
  new IntersectionObserver(entries => {
    const visible = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
    stickyBar.classList.toggle('sticky-bar--visible', visible);
    stickyBar.setAttribute('aria-hidden', String(!visible));
    stickyBar.inert = !visible;
  }).observe(buy);
  stickyBuy.addEventListener('click', () => {
    form.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    buy.focus({ preventScroll: true });
  });
  setCard(cards[0]);
  sync();
})();
